<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
document.querySelectorAll('.productView-video').forEach(function(element) {
    element.innerHTML = element.innerHTML.replace(/&gt;/g, '').replace(/"/g, '');
});

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
